<template>
  <div class="d-flex align-items-center min-vh-100 login-box">
    <b-container>
      <b-row class="justify-content-center">
        <c-col md="9" lg="6" class="login">
          <b-card class="p-4 mb-0 card">
            <b-form v-on:submit.prevent="checkForm">
              <div class="text-center">
                <h1>LOGIN</h1>
              </div>
              <div >
                <InputText
                  class="my-4 login-input"
                  v-model="form.Email"
                  textFloat="Email"
                  placeholder="Email"
                  type="email"
                  name="email"
                  isRequired
                  :isValidate="$v.form.Email.$error"
                  :v="$v.form.Email"
                  @onKeyup="submitFormOnInput"
                />

                <InputText
                  class="my-4 login-input"
                  v-model="form.Password"
                  textFloat="Password"
                  placeholder="Password"
                  type="password"
                  name="password"
                  isRequired
                  :isValidate="$v.form.Password.$error"
                  :v="$v.form.Password"
                  @onKeyup="submitFormOnInput"
                />
                <b-row>
                  <c-col class="text-center">
                    <b-button
                      type="button"
                      class="px-4 login-btn"
                      @click="checkForm"
                      :disabled="isDisable"
                      >LOGIN</b-button
                    >
                  </c-col>
                </b-row>
              </div>
            </b-form>
          </b-card>
        </c-col>
      </b-row>
    </b-container>
    <Loading />
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import { required, email, minLength } from "vuelidate/lib/validators";
import InputText from "@/components/inputs/InputText";

export default {
  name: "Login",
  components: {
    InputText,
    Loading,
  },
  data() {
    return {
      error: "",
      form: {
        Email: "",
        Password: "",
      },
      isLoading: false,
      isDisable: false,
      settingAzure: {
        enable_single_sign_on_azure_active_directory: 0,
        client_id: "",
        azure_endpoint: "",
      },
      step: 1,
    };
  },
  validations() {
    return {
      form: {
        Email: { required, email },
        Password: { required, minLength: minLength(6) },
      },
    };
  },
  beforeCreate() {
    if (this.$cookies.get("print_tag_admin_token")) {
      window.location.href = "/welcome";
    }
  },

  async created() {
    await this.GetLoginAzureSetting();
  },
  methods: {
    async GetLoginAzureSetting() {
    const res =  await this.axios.get(
          `${process.env.VUE_APP_API}/Setting/get_login_azure_setting`
        );
    if(res.data.result){
      this.settingAzure = res.data.detail
    }
    },
    submitFormOnInput: function (e) {
      if (e.keyCode === 13) {
        this.checkForm();
      }
    },
    checkForm: async function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;
      this.isDisable = true;
      this.$bus.$emit("showLoading");
      const res  = await  this.axios.post(
          `${process.env.VUE_APP_API}/Login/login` , this.form
        );
      this.isDisable = false;

      if (res.data.result == 1) {
        this.error = "";
        this.$cookies.set("print_tag_admin_token", res.data.detail.token, "7d");
        this.$cookies.set(
          "print_tag_admin_user_guid",
          res.data.detail.user_guid,
          "7d"
        );
        this.$cookies.set("back_office_admin_email", res.data.detail.email, "7d");
        this.$cookies.set(
          "back_office_admin_userName",
          res.data.detail.userName,
          "7d"
        );
        this.$bus.$emit("hideLoading");
        window.location.href = this.$route.query.nextUrl || "/welcome";
      } else {
        this.$swal2.fire(res.data.message, "", "error");
        this.$bus.$emit("hideLoading");
        this.error = res.data.message;
      }
    },
  },
};
</script>

<style scoped>
.login-box {
  background-color: var(--primary-color);
}
.card {
  width: 100%;
  background-color: #ffffff;
  border: transparent solid 1px;
  /* border-top-left-radius: 20%; */
  /* border-bottom-right-radius: 20%; */
  box-shadow: 0px 4px 15px -3px #7b7b7b;
}

h1 {
  color: var(--primary-color);
}
.login-btn {
  padding: 8px !important;
  font-size: 15px;
  border-radius: 10px !important;
  background: #ffffff;
  border: var(--primary-color) solid 1px;
  color: var(--primary-color);
  text-align: center;
  width: 25%;
  margin: auto;
  transition: 0.3s;
}

.login-btn:hover {
  /* color: var(--primary-color); */
  background-color: var(--primary-color);
  color: #ffffff;
}
.login {
  max-width: 500px;
}
.btn-link-custom {
  color: var(--font-main-color);
  margin-top: 15px;
  padding: 0 !important;
}
@media (max-width: 600px) {
  .card-body {
    padding: 1.25rem 0;
  }
  .login-btn {
    width: 100% !important;
  }
}
</style>
